import { useContext } from 'react';

import { LocaleContext, LocaleContextType } from '../components/LocaleProvider';

/**
 * Hook to make both the current locale and associated Bloomberg-specific language code
 * available.
 */
export function useBBUILocale(): LocaleContextType {
    const context = useContext(LocaleContext);
    if (context === undefined) {
        throw new Error('useBBUILocale must be used inside of a LocaleProvider');
    }
    return context;
}
